<script setup lang="ts">
import { useAreas, useCategories } from '@ilteducation/content-ref-data';
import { computed } from 'vue';
import config from '@/config/ConfigProvider';
import type { Video } from '@ilteducation/videos';
import { useRoute } from 'vue-router';

defineProps<{
  video: Video;
}>();

const { areas } = useAreas();
const { categories } = useCategories();
const route = useRoute();

const subject = computed(() => categories.value.find((c) => c.slug === route.params.subject));
const area = computed(() =>
  areas.value.find((a) => a.slug === route.params.area && a.categoryId === subject.value?.id),
);

const logoImageBWFile = config.value('logoImageBWFile');
const logoImageBWFileUrl = computed(() => new URL(`/src/assets/images/${logoImageBWFile}`, import.meta.url).href);
</script>

<template>
  <div class="v-container print-keywords">
    <div class="print-keywords-header">
      <div>
        <div class="print-keywords-breadcrumbs">
          <span>{{ subject?.category }}</span>
          <span> / </span>
          <span class="d-inline-flex">{{ area?.name }}</span>
        </div>
        <p v-if="video" class="print-keywords-header-ttl">{{ video.title }}</p>
        <div>
          <slot name="languages"></slot>
        </div>
      </div>
      <div>
        <img class="toolbar-logo-small" :src="logoImageBWFileUrl" alt="" />
      </div>
    </div>
    <!--keywords view-->
    <div class="keyword-container">
      <slot></slot>
    </div>
    <!--END keywords view-->
  </div>
</template>

<style lang="scss" scoped>
.print-keywords {
  font-size: 1rem;
  margin-top: 30px;
  &-header {
    display: flex;
    justify-content: space-between;
    height: 100px;
  }

  &-header-ttl {
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 10px;
  }

  &-breadcrumbs {
    font-size: 0.75rem;
  }
  .keyword-container {
    page-break-inside: auto;
  }

  .keyword-row {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  .keyword-row__flash-cards {
    page-break-inside: avoid;
    page-break-after: auto;
    box-shadow: none !important;
    .keyword-wrap {
      border: 1px solid #d6dbde;
      box-shadow: none !important;
      &:nth-child(2n) {
        border-left: none;
      }
      &:nth-child(n + 3) {
        border-top: none;
      }
      .keyword-item__right {
        border-left: none;
      }
    }
  }
}
</style>
